import { formatDate } from "../utils";

const defaultAttributes = {
  title: 'Untitled event',
  productId: 'bitcentralfuel/ics',
  method: 'PUBLISH',
  timestamp: formatDate(null, 'utc'),
  start: formatDate(null, 'utc')
}

export default function buildEvent(attributes:any = {}) {
  const {
    title,
    productId,
    method,
    uid,
    sequence,
    startDate,
    start,
    startType,
    duration,
    endDate,
    end,
    description,
    url,
    geo,
    location,
    status,
    categories,
    organizer,
    attendees,
    alarms,
    recurrenceRule,
    created,
    lastModified,
    calName,
    htmlContent,
    timezone,
    attachedFuelDisplayClassName,
    attachedFuelEventFlags,
    attachedFuelGraphicsConfig,
    attachedFuelCustomAttributes,
    fieldDictionary
  } = attributes;

  // fill in default values where necessary
  const output = Object.assign({}, defaultAttributes, attributes);

  // remove undefined values
  return Object.entries(output).reduce(
      (clean, entry) => typeof entry[1] !== 'undefined' ? Object.assign(clean, {[entry[0]]: entry[1]}) : clean,
      {}
  )
}
